<div
    *ngIf="errorMessage"
    class="w-full mb-4 text-center text-red-600 text-base font-semibold animate-fade-in"
>
    {{ errorMessage }}
</div>
<form
    #signInForm="ngForm"
    class="space-y-6"
    (submit)="signIn()"
    [ngClass]="{ shake: shake }"
>
    <div>
        <label for="email" class="block text-[18px] font-medium text-black"
            >Email address</label
        >
        <div class="mt-1">
            <input
                [(ngModel)]="emailAddress"
                id="email"
                name="email"
                type="email"
                autocomplete="email"
                required
                class="input-text"
            />
        </div>
    </div>

    <div>
        <label for="password" class="block text-[18px] font-medium text-black"
            >Password</label
        >
        <div class="mt-1">
            <input
                [(ngModel)]="password"
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                class="input-text"
            />
        </div>
    </div>

    <div class="flex items-center justify-between">
        <div class="flex items-center">
            <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                [(ngModel)]="rememberMe"
                class="h-4 w-4 rounded border-gray-300 text-brand-primary-strong focus:ring-brand-primary-strong"
            />
            <label for="remember-me" class="ml-2 block text-sm text-gray-900"
                >Remember me</label
            >
        </div>

        <div class="text-sm">
            <a
                [routerLink]="[
                    '/account/forgotten-password',
                    { email: this.emailAddress ?? '' }
                ]"
                class="font-medium text-brand-primary-strong hover:text-brand-primary-strong"
                >Forgot your password?</a
            >
        </div>
    </div>
    <button
        type="submit"
        [disabled]="signInForm.invalid || signInForm.pristine || signInInProgress"
        class="w-full bg-brand-primary px-4 py-2 rounded-[6px] border-brand-primary-strong border-[1px] text-white"
    >
        Sign in
    </button>
    <div
        *ngIf="displayRegisterLink"
        class="text-sm font-medium text-brand-primary-strong hover:text-brand-primary-strong mx-auto"
    >
        <a [routerLink]="['/account/register']">No account? Register here</a>
    </div>
</form>
